import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner } from "./UI/Spinner";
import { useUnrestrictedEffect } from "./useUnrestrictedEffect";
import { ErrorWindow } from "components/ErrorWindow";

import "./InstallScreen.css";

export const InstallScreen = () => {
  const navigate = useNavigate();
  const { installToken } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const handleClick = () => {
    if (loading) {
      setLoading(false);
      setError("Something went wrong");
      // navigate("/");
    }
  };

  useUnrestrictedEffect({
    loadFn: () => {
      const getAccessToken = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/install_button`,
            {
              method: "POST",
              body: JSON.stringify({ installToken }),
            }
          );
          const result = await response.json();
          if (result?.error || result?.message) {
            setError(result?.error || result?.message);
            return;
          }

          window.localStorage.setItem(`accessToken`, result?.accessToken);
          window.localStorage.setItem(
            `buttonTokens`,
            JSON.stringify(result?.buttonTokens)
          );

          navigate(`/`);
        } catch (err) {
          setError(err?.message ?? "Something went wrong");
        } finally {
          setLoading(false);
        }
      };

      getAccessToken();
    },
  });

  return (
    <div className="InstallScreen" onClick={handleClick}>
      {loading && <Spinner />}
      {error && <ErrorWindow handleClose={() => navigate("/")} error={error} />}
    </div>
  );
};
